var React = require('react');

function Error (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("rect",{"fill":"none","width":"24","height":"24","key":1}),React.createElement("path",{"d":"M15,3A12,12,0,1,0,27,15,12,12,0,0,0,15,3Zm1.2,18H13.8V18.6h2.4Zm0-4.8H13.8V9h2.4Z","transform":"translate(-3 -3)","key":2})]);
}

Error.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Error;

Error.default = Error;
